import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { DropdownSelect } from '../dropdown-select/DropdownSelect';
import { useDictionaryTranslation } from '../../hooks/useDictionaryTranslation';
import { InteroperableDataService } from '../../services/interoperableDataService';

export const SelectPersonCondition = ({
  selectedPersonCondition,
  onChange,
  disabled,
  placeholder = 'personConditionPlaceholder',
}) => {
  const { translate: t } = useDictionaryTranslation();
  const [personConditions, setPersonConditions] = useState([]);
  const [loading, setLoading] = useState(false);

  const selectPersonCondition = (item) => {
    const personCondition = item ? personConditions.find((dt) => dt.value === item.value) : null;
    onChange(personCondition);
  };

  const getPersonConditions = useCallback(async (search) => {
    setLoading(true);
    try {
      const params = { search, isServiceCreation: true };
      const result = await InteroperableDataService.getPersonConditions(params);
      setPersonConditions(result.personConditions);
    } catch (error) {
      setPersonConditions([]);
    } finally {
      setLoading(false);
    }
  }, []);

  const getOptionData = useCallback((personCondition) => {
    return {
      value: personCondition.value,
      label: personCondition.description,
    };
  }, []);

  return (
    <DropdownSelect
      placeholderText={t(placeholder)}
      isLoading={loading}
      onChange={selectPersonCondition}
      options={personConditions}
      value={selectedPersonCondition}
      onSearch={getPersonConditions}
      getOptionData={getOptionData}
      disabled={disabled}
    />
  );
};

SelectPersonCondition.propTypes = {
  selectedPersonCondition: PropTypes.shape({
    value: PropTypes.string,
    description: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
};
